import React from "react";
import { ProductConsumer } from "../../context";
import CartItems from "./CartItems";

export default function CartList() {
	return (
		<div className="container-fluid mt-3">
			<div className="row">
				<div className="col">
					<ProductConsumer>
						{(value) => {
							const { cart, increment, decrement, removeItem } = value;
							if (cart.length === 0) {
								return <h1 className="text-title text-center my-4">Kurven er tom</h1>;
							}
							return(
								<>
								{cart.map(item =>(<CartItems key={JSON.stringify(item)} cartItem={item} increment={increment} decrement={decrement} removeItem={removeItem}></CartItems>))}
								</>
							)
						}}
					</ProductConsumer>
				</div>
			</div>
			
		</div>
	);
}